/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_InvoiceLineGet } from '../models/Model_InvoiceLineGet';
import type { Model_InvoiceLinePost } from '../models/Model_InvoiceLinePost';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoiceLineService {
    /**
     * @param invoiceId
     * @param requestBody
     * @returns Model_InvoiceLineGet Success
     * @throws ApiError
     */
    public static postApiV1InvoiceLine(
        invoiceId: ConvertDatesToStrings<string>,
        requestBody?: ConvertDatesToStrings<Model_InvoiceLinePost>,
    ): CancelablePromise<Array<Model_InvoiceLineGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoiceLine/{invoiceId}',
            path: {
                'invoiceId': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
